export default __webpack_public_path__ + "static/media/Background 5_00073.9bc4b048.png";